import { connect } from 'datocms-plugin-sdk';
import { render } from './utils/render';
import ConfigScreen from './entrypoints/ConfigScreen';
import { AEVariantsSelector } from './components/AEVariantsSelector';
import 'datocms-react-ui/styles.css';

connect({
  renderConfigScreen(ctx) {
    return render(<ConfigScreen ctx={ctx} />);
  },
  manualFieldExtensions(ctx) {
    return [
      {
        id: 'Amplitude Exp Variants',
        // Mirror the installation's display name so the field-editor tile
        // always matches the Configuration > Plugins list ([Prev]/[Prod]).
        name: ctx.plugin.attributes.name || 'Amplitude Exp Variants',
        type: 'editor',
        fieldTypes: ['json'],
      },
    ];
  },
  renderFieldExtension(id, ctx) {
    render(<AEVariantsSelector ctx={ctx}/>);
  },
});
